import type {FaqItem} from '@cohort/shared/schema/common/campaign';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import {Disclosure} from '@headlessui/react';
import {CaretDown} from '@phosphor-icons/react';
import React from 'react';

type FaqQuestionCardProps = {
  faqItem: FaqItem;
  hasDarkBg: boolean;
  accentColor: string;
};

const FaqQuestionCard: React.FC<FaqQuestionCardProps> = ({faqItem, accentColor, hasDarkBg}) => (
  <Disclosure
    as="div"
    key={faqItem.question}
    className={classNames(
      'mb-2 w-full cursor-pointer rounded-xl',
      hasDarkBg ? 'bg-white/8' : 'bg-black/4'
    )}
  >
    {({open}) => (
      <React.Fragment>
        <dt className="text-lg ">
          <Disclosure.Button
            as="div"
            className="flex w-full items-center justify-between px-6 py-4 text-left text-lg"
          >
            <span
              className={classNames(
                'align-middle text-sm font-medium',
                hasDarkBg ? 'text-white' : 'text-black/90'
              )}
            >
              {faqItem.question}
            </span>
            <div style={{color: accentColor}} className="ml-6 flex h-7 items-center">
              <CaretDown
                className={classNames(
                  'h-6 w-6 transform duration-200',
                  open ? '-rotate-0' : '-rotate-90'
                )}
                aria-hidden="true"
              />
            </div>
          </Disclosure.Button>
        </dt>
        <Disclosure.Panel as="dd" className="px-6 pb-4 pr-12">
          <div
            dangerouslySetInnerHTML={{__html: faqItem.answer}}
            className={classNames(
              hasDarkBg ? 'text-white/50' : 'text-black/50',
              'prose prose-sm m-0 cursor-text text-justify text-sm font-medium focus:outline-none',
              hasDarkBg && 'prose-invert'
            )}
          />
        </Disclosure.Panel>
      </React.Fragment>
    )}
  </Disclosure>
);

export default FaqQuestionCard;
